import { render } from "./Pencil.vue?vue&type=template&id=127e2baf"
import script from "./Pencil.vue?vue&type=script&lang=js"
export * from "./Pencil.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "127e2baf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('127e2baf', script)) {
    api.reload('127e2baf', script)
  }
  
  module.hot.accept("./Pencil.vue?vue&type=template&id=127e2baf", () => {
    api.rerender('127e2baf', render)
  })

}

script.__file = "src/icons/components/filled/Pencil.vue"

export default script